export function shopDynamicSidebar() {
    const container = document.querySelector( '.shop-dynamic-sidebar' );

    if (!container) {
        return;
    }

    async function init() {
        const $query = window.location.href.split('?')[1];
        const ajaxUrl = window.app.ajax_url + '?' + $query;
        const formData = new FormData();
        const categoryId = container.dataset.categoryId;
        formData.append( 'action', 'fetch_shop_dynamic_sidebar' );
        formData.append( 'category_id', categoryId );
        const response = await fetch( ajaxUrl, {
            method: 'POST',
            body: formData
        } );
        container.innerHTML = await response.text();
    }

    init();
}
